export default __webpack_public_path__ + "static/media/08_Livingroom-Interior-Architecture-EschweilerPhotography04.ad910480.jpg";